import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Root redirect. `merchant-panel` is a super-app hosting several sub-apps
 * (Eats, Delivery, Pharmacy, Shop, Buchet), each under its own path namespace.
 * `/` forwards to the `/welcome` launcher, where the merchant chooses one — the
 * sub-app catalog behind it lives in `entities/sub-app`.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/welcome' });
  },
});
